import React, { useState, useEffect } from 'react';
import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { apiFile } from 'services/data';
import { useToast } from 'hooks/toast';
import { useUrl } from 'hooks/url';

import { Loading, Card, Template } from 'components';

type FilesData = {
  id: number;
  arquivo: string;
  hora: string;
  rede_pessoa: {
    nome: string;
  };
};

const AdministrativoArquivoGeralComunicados = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [files, setFiles] = useState<FilesData[]>([]);
  const { addToast } = useToast();
  const { urlCrm } = useUrl();

  useEffect(() => {
    async function fetchData() {
      try {
        await apiFile
          .geral('Comunicados')
          .then((response) => setFiles(response.data));
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao buscar os arquivos',
          description: (err as Error).message,
        });
      }
      setIsLoading(false);
    }
    fetchData();
  }, [addToast]);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Template>
          <div className='archive-content'>
            {files.length > 0 ? (
              files.map((item) => {
                const extensao = item.arquivo.split('.').pop() || 'png';
                return (
                  <Card
                    key={item.id}
                    image={`${urlCrm}/licenciado/0/${item.id}.${extensao}`}
                    extensao={extensao}
                    text={item.arquivo
                      .split('_')
                      .join(' ')
                      .split('.')
                      .slice(0, -1)
                      .join('')}
                    legend={`${item.rede_pessoa.nome} - ${format(
                      parseISO(item.hora.toString()),
                      'dd/MM/yyyy HH:mm:ss',
                      {
                        locale: ptBR,
                      }
                    )}`}
                    path={`${urlCrm}/licenciado/0/${item.id}.${extensao}`}
                  />
                );
              })
            ) : (
              <span style={{ margin: '0 auto', color: 'var(--grey)' }}>
                Desculpe, nenhum comunicado encontrado
              </span>
            )}
          </div>
        </Template>
      )}
    </>
  );
};

export default AdministrativoArquivoGeralComunicados;
